import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const YoutubeIconContainer = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const StoryItemContent = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutral[200]}`,
  borderTop: 'none',
  maxWidth: '100%',
  flex: 1,
  backgroundColor: 'white',
}));

export const StoryDescription = styled(Typography)(({ theme }) => ({
  flex: 1,
  display: '-webkit-box',
  '-webkit-line-clamp': '4',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  '&:hover': {
    color: theme.palette.neutral[800],
  },
}));

export const StoryItemContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '0.5rem',
  [theme.breakpoints.up('sm')]: {
    padding: '1rem',
  },
}));
